import palette from './palette';

const robotoMedium = '"Roboto Medium", "Helvetica", "Arial", sans-serif';

export default {
  h1: {
    fontFamily: robotoMedium,
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: '32px',
    letterSpacing: '0',
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: robotoMedium,
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: '28px',
    letterSpacing: '0',
    lineHeight: 1.2,
  },
  h3: {
    fontFamily: robotoMedium,
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: '24px',
    letterSpacing: '0',
    lineHeight: 1.2,
  },
  h4: {
    fontFamily: robotoMedium,
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: '20px',
    letterSpacing: '0',
    lineHeight: 1.2,
  },
  h5: {
    fontFamily: robotoMedium,
    color: palette.text.primary,
    fontSize: '16px',
    lineHeight: 1.2,
  },
  h6: {
    fontFamily: robotoMedium,
    color: palette.text.primary,
    fontSize: '12px',
    lineHeight: 1.2,
  },
  subtitle1: {
    fontFamily: robotoMedium,
    color: palette.text.primary,
    fontSize: '16px',
    lineHeight: '18px',
  },
  subtitle2: {
    color: palette.text.secondary,
    fontSize: '16px',
    lineHeight: '18px',
  },
  body1: {
    color: palette.text.primary,
    fontSize: '14px',
    lineHeight: '16px',
  },
  body2: {
    color: palette.text.secondary,
    fontSize: '12px',
    lineHeight: '14px',
  },
  button: {
    fontFamily: robotoMedium,
    color: palette.text.primary,
    fontSize: '14px',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '11px',
    lineHeight: '13px',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
  },
};
